import React from "react";
import {findIndex, isEmpty, isUndefined} from "lodash";
import GoogleMapReact from "google-map-react";
import {Link} from "react-router-dom";

const AnyReactComponent = ({place, category}) => {
    const {id, name, slug, categories} = place;

    let url = `/places/details/${id}/${slug}`;

    return (
        <Link
            to={url}
            key={`marker-point-${id}`}
        >
            <div>
                <img src={'/images/map-pin.svg'} title={name} alt={name} width={32}/>
            </div>
        </Link>
    );
};

export const Maps = ({markers, category}) => {

    const lat_ = -19.917270;
    const lng_ = -43.953950;

    const first = findIndex(markers, function (p) {
        return p.lat && p.lng;
    });

    let lat, lng = false;
    if (first > -1) {
        lat = Number(markers[first]['lat']);
        lng = Number(markers[first]['lng']);
    }

    return (
        <GoogleMapReact
            bootstrapURLKeys={{key: 'AIzaSyBEokzP4L4HhKoRtvRMv21faDsC9qpUbIU'}}
            defaultCenter={[lat_, lng_]}
            center={[lat, lng]}
            defaultZoom={15}
            yesIWantToUseGoogleMapApiInternals
        >
            {
                markers.map((marker) => {
                    if (isEmpty(marker.lat) || isEmpty(marker.lng)) {
                        return null;
                    }

                    const {id, lat, lng} = marker;
                    return (
                        <AnyReactComponent
                            key={`marker-${id}`}
                            lat={lat}
                            lng={lng}
                            place={marker}
                        />
                    );
                })
            }
        </GoogleMapReact>
    );
};